/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DueDays/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaInputWithLabelField from 'DesignSystem/TysiaInputWithLabelField/index'



/** @type {import('Simple/types.js').View} */
export default function DueDays({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/TaskUpdate/DueDays",
  onChange
  
}) {
let eventActionDataDueInDaysValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'data.due_in_days',
})
let eventActionDataDueInDaysChangeData = fromData.useDataChange({ viewPath,
context: 'event_action',
path: 'data.due_in_days',
})
  return (<React.Fragment
>
<TysiaInputWithLabelField
  viewPath={`${viewPath}/TysiaInputWithLabelField`}
 type="number"
 data="event_action.data.due_in_days"
 value={eventActionDataDueInDaysValueData}
 onChange={eventActionDataDueInDaysChangeData}
 marginTop={-4}
 size="small"
 width={120}
 backgroundColor="white"
 placeholder="+ Days"
/>
{children}
</React.Fragment>)
}